import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { TopNav } from "@/components/TopNav";
import { api } from "@/lib/api";
import { BillingBanner } from "@/components/BillingBanner";
import { LegalFooter } from "@/components/LegalFooter";
import { DollarGrownDialog } from "@/components/DollarGrownDialog";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

function PlainHeader() {
  const { logout } = useAuth();
  return (
    <header className="flex items-center justify-between border-b border-[#E7DECF] bg-[#FAF7F1] px-4 py-4 sm:px-8" data-testid="plain-header">
      <Logo />
      <button type="button" onClick={logout} className="text-sm text-slate-500 hover:underline" data-testid="plain-header-logout">Cerrar sesión</button>
    </header>
  );
}

export function AppLayout() {
  const { user } = useAuth();
  const paid = !!user && user.billing?.access === "full";
  useEffect(() => { if (paid) api.post("/mentor/weekly").catch(() => undefined); }, [paid]);
  return (
    <div className="min-h-screen bg-slate-50" data-testid="app-layout">
      {paid ? <><TopNav /><DollarGrownDialog /><BillingBanner /></> : <PlainHeader />}
      <main className="mx-auto max-w-7xl px-4 pb-20 pt-8 sm:px-8 sm:pt-12">
        <Outlet />
        <LegalFooter className="mt-16 border-t border-[#DDE1E8] pt-6" />
      </main>
    </div>
  );
}
